import { BaseRequest } from "./baseRequest";
import { BaseObject } from "../../../../shared";

export class DefaultRequest extends BaseRequest {

  data?: BaseObject;

}